module.exports = __webpack_public_path__ + "img/com_keio.870eefb8.png";